import React, { useState, useContext, useRef, useEffect } from 'react';
import useObjectState from "../../../Hooks/useObjectState";
import { AppContext } from '../../../AppContext';
import icons from '../../../icons';
import IconButton from '../../Buttons/IconButton/IconButton';
import Switch from '../../Switch/Switch';
import Popup from '../../Popup/Popup';
import style from './Option.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import { auth, db } from '../../../firebase';
import { deleteDoc, doc, setDoc, updateDoc, deleteField, onSnapshot, getDocs, query, collection, getDoc, arrayRemove } from 'firebase/firestore';
import { deleteUser, signOut, updatePassword, verifyBeforeUpdateEmail } from 'firebase/auth';
import ErrorSnackbar from '../../ErrorSnackbar/ErrorSnackbar';
import urls from '../../../urls';
import { authenticateClassroomAPI, fetchEvents, loadClassroomAPI, revokeToken, getCourses, isLoggedIn, getAccessToken } from "../../../classroom";

import Lottie from 'lottie-react';
import brainstorming_animation from "../../../lottieAnimations/brainstorming_animation.json";
import students_animation from "../../../lottieAnimations/students_animation.json"
import TextButton from '../../Buttons/TextButton/TextButton';
import Checkbox from '../../Checkbox/Checkbox';
import Banner from '../../Banner/Banner';
import constants from '../../../constants';


let prevScrollTime = (new Date()).getTime()
let prevScroll = 0;

const prettifyDate = date => String(date).length === 1 ? `0${date}` : String(date);
// let updateProfileTimeout;
// let updatingProfile = {/* rendered: false, */changed: false, lastTyped: (new Date()).getTime() };

const getOS = () => {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
  
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }
  
    return os;
};



const addDays = (date, days) => {
    let newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

const getItalianMonth = month => {
    switch(month) {
        case 0:
            return "Gennaio";
        case 1:
            return "Febbraio";
        case 2:
            return "Marzo";
        case 3:
            return "Aprile";
        case 4:
            return "Maggio";
        case 5:
            return "Giugno";
        case 6:
            return "Luglio";
        case 7:
            return "Agosto";
        case 8:
            return "Settembre";
        case 9:
            return "Ottobre";
        case 10:
            return "Novembre";
        case 11:
            return "Dicembre";
    }
};

const Option = props => {
    const { user, setUser, schoolUsers, subjects, setSubjects, deleteSubject: deleteSubjectsProperty, timetable, setTimetable, homeworks, setHomeworks, setSchoolPresidents, setNewEvents, setUpdatedEvents, offline, setPage: setGlobalPage, registerAccessToken, setRegisterAccessToken } = useContext(AppContext);

    const [page, setPage] = useState({ page: null, subPage: null });
    const [title, setTitle] = useState(props.title);
    const [shrink, setShrink] = useState(false);
    const [bugReport, setBugReport] = useState({ sending: false, text: "" });
    const [deleteSubjectModal, setDeleteSubjectModal] = useState({ show: false, subject: null, loading: false });
    const [newSubject, setNewSubject] = useState({ name: "", icon: null, saving: false });
    const [timetableDay, setTimetableDay] = useState(props.timetableDay ?? 0);
    const [deleteTimetableClassModal, setDeleteTimetableClassModal] = useState({ show: false, timetableClass: null });
    const [newTimetableClass, setNewTimetableClass] = useState({ subject: "", startHour: `${prettifyDate((new Date()).getHours())}:${prettifyDate((new Date()).getMinutes())}`, endHour: `${prettifyDate((new Date()).getHours())}:${prettifyDate((new Date()).getMinutes())}`, saving: false });
    const [showTimePicker, setShowTimePicker] = useState({ startHour: false, endHour: false });
    const [searchingSubjects, setSearchingSubjects] = useState(false);
    const [classroomSubjectPopup, setClassroomSubjectPopup] = useState({ show: false, subject: null, course: null });
    const [registerSubjectPopup, setRegisterSubjectPopup] = useState({ show: false, subject: null, course: null });

    const [email, setEmail] = useState(user?.email);
    const [username, setUsername] = useState(user?.username);
    const [profilePic, setProfilePic] = useState(user?.profilePicture);
    const [error, setError] = useState({ show: false, error: "" });
    const [profileLoading, setProfileLoading] = useState(false);
    const [profilePopup, setProfilePopup] = useState({ show: false, loading: false, icon: null, text: "", buttons: null });

    const [classroomCourses, setClassroomCourses] = useState(null);
    const [classroomAccessToken, setClassroomAccessToken] = useState(null);
    const [loadingClassroom, setLoadingClassroom] = useState(true);

    const [registerCourses, setRegisterCourses] = useState(null);
    const [loadingRegister, setLoadingRegister] = useState(true);
    
    const [generatingStripeCheckout, setGeneratingStripeCheckout] = useState(false);
    const [premiumSubscriptionCancel, setPremiumSubscriptionCancel] = useState({ showModal: false });
    const [premiumInviteLinkCopied, setPremiumInviteLinkCopied] = useState(false);

    const [showSchoolPresidentsPopup, setShowSchoolPresidentsPopup] = useState(false);
    const [schoolPresidentsData, setSchoolPresidentsData] = useObjectState({});
    const [validatingPresidents, setValidatingPresidents] = useState(false);
    const [deleteSchoolListPopup, setDeleteSchoolListPopup] = useState(false);
    const [schoolList, setSchoolList, deleteSchoolList, updateSchoolList] = useObjectState({});
    const [schoolLists, setSchoolLists, deleteSchoolLists, updateSchoolLists] = useObjectState({});
    const [invitingMembersToSchoolList, setInvitingMembersToSchoolList] = useState(false);
    const [schoolListLoading, setSchoolListLoading] = useState(false);
    const [searchMember, setSearchMember] = useState("");
    const [votedSchoolPresidents, setVotedSchoolPresidents] = useState([]);

    const [calendar, setCalendar] = useState(null);
    const [calendarActiveSlide, setCalendarActiveSlide] = useState(0);
    const [date, setDate] = useState(new Date());
    const [swiperLoaded, setSwiperLoaded] = useState(null);
    const [updatingTermsSeparator, setUpdatingTermsSeparator] = useState(false);

    const swiper = useRef();
    
    const timetableSwiper = useRef();

    const copyPremiumInviteLink = () => {
        navigator.clipboard.writeText(`https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}&user=${user.id}`);
        setPremiumInviteLinkCopied(true);
    };

    const deleteSubject = async () => {
        setDeleteSubjectModal(oldDeleteSubjectModal => ({ ...oldDeleteSubjectModal, loading: true }));
        await deleteDoc(doc(db, `schools/${user.school}/classes/${user.class}/subjects`, deleteSubjectModal.subject));
        deleteSubjectsProperty(deleteSubjectModal.subject);
        setDeleteSubjectModal({ show: false, subject: null, loading: false });
    };

    const saveSubject = async () => {
        if (!newSubject.name || !newSubject.icon) {
            setError({ show: true, error: "Riempi tutti i campi!" });
            return;
        }
        
        setNewSubject(oldNewSubject => ({ ...oldNewSubject, saving: true }));
        await setDoc(doc(db, `schools/${user.school}/classes/${user.class}/subjects`, newSubject.name), { subject: newSubject.name, icon: newSubject.icon });
        setSubjects(oldSubjects => ({ ...oldSubjects, [newSubject.name]: { subject: newSubject.name, icon: newSubject.icon } }))

        setNewSubject({ name: "", icon: null, saving: false });
        setTitle("Materie");
        setPage({ page: null });
    };

    const editSubject = subject => {
        setPage({ page: "subjectsAdd" });
        setNewSubject({ name: subject.subject, icon: subject.icon, saving: false }); // Update with actual subject data
    };

    const getIconBySubjectName = (subjectName=null) => {
        const toReturn = [[], []], 
            name = subjectName?.toLowerCase() ?? newSubject.name.toLowerCase();

        Object.entries(icons.subjects_icons_by_name).forEach(([iconName, subjects]) => {
            if ((subjects.includes(name) || subjects.map(subject => subject.includes(name)).some(included => included)) && name) 
                toReturn[0].push(iconName);
            else
                toReturn[1].push(iconName);
        });

        return toReturn;
    };

    const setNewSubjectIcon = icon => {
        if (newSubject.name)
            setNewSubject(oldNewSubject => ({ ...oldNewSubject, icon }));
    };

    const swipeTimetablePage = day => {
        setTimetableDay(day);
        timetableSwiper.current?.swiper?.slideTo(day);
    };

    const sortTimetableFunction = (first, second) => {
        const [firstHour, firstMinute] = first[0].split(":");
        const [secondHour, secondMinute] = second[0].split(":");
        return (parseInt(firstHour) > parseInt(secondHour) || (parseInt(firstHour) === parseInt(secondHour) && parseInt(firstMinute) > parseInt(secondMinute))) ? 1 : -1;
    };

    const sortTimetable = toSort => Object.fromEntries(Object.entries(toSort).sort(sortTimetableFunction));

    const deleteTimetableClass = async () => {
        await updateDoc(doc(db, `schools/${user.school}/classes/${user.class}/timetable/${String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)}`), { [deleteTimetableClassModal.timetableClass]: deleteField() });
        const oldDayTimetable = timetable[String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)];
        delete oldDayTimetable[deleteTimetableClassModal.timetableClass];

        setTimetable(oldTimetable => ({
            ...oldTimetable,
            [String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)]: sortTimetable(oldDayTimetable)
        }));
        setDeleteTimetableClassModal({ show: false, timetableClass: null });
    };

    const saveTimetableClass = async () => {
        if (!newTimetableClass.subject || !newTimetableClass.startHour || !newTimetableClass.endHour) {
            setError({ show: true, error: "Riempi tutti i campi!" });
            return;
        }

        if (parseInt(newTimetableClass.endHour.split(":")[0]) < parseInt(newTimetableClass.startHour.split(":")[0]) || (parseInt(newTimetableClass.endHour.split(":")[0]) === parseInt(newTimetableClass.startHour.split(":")[0]) && parseInt(newTimetableClass.endHour.split(":")[1] < parseInt(newTimetableClass.startHour.split(":")[1])))) {
            setError({ show: true, error: "Orario non valido!" });
            return;
        }

        setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, saving: true }));
        try {
            await updateDoc(doc(db, `schools/${user.school}/classes/${user.class}/timetable`, String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)), { [newTimetableClass.startHour]: { startTime: newTimetableClass.startHour, endTime: newTimetableClass.endHour, subjectTitle: newTimetableClass.subject } });
        } catch (err) {
            await setDoc(doc(db, `schools/${user.school}/classes/${user.class}/timetable`, String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)), { [newTimetableClass.startHour]: { startTime: newTimetableClass.startHour, endTime: newTimetableClass.endHour, subjectTitle: newTimetableClass.subject } });
        }

        const newTimetable = {
            ...timetable,
            [String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)]: sortTimetable({
                ...timetable[String(timetableDay !== 6 ? parseInt(timetableDay) + 1 : 0)],
                [newTimetableClass.startHour]: { startTime: newTimetableClass.startHour, endTime: newTimetableClass.endHour, subjectTitle: newTimetableClass.subject }
            })
        };
        setTimetable(newTimetable);

        setNewTimetableClass({ subject: "", startHour: `${prettifyDate((new Date()).getHours())}:${prettifyDate((new Date()).getMinutes())}`, endHour: `${prettifyDate((new Date()).getHours())}:${prettifyDate((new Date()).getMinutes())}`, saving: false });
        setTitle("Orario");
        setPage({ page: null });
    };

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_orange_icon";
        if (subjects)
            Object.values(subjects).forEach(subject => {
                if (subject.subject.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
            });

        return returnIcon;
    };

    const logout = async () => {
        if (profileLoading)
            return;

        setProfileLoading(true);

        fetch(urls.unsubscribe, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: user.id }),
        });

        console.log("Logout");
        setLoadingClassroom(true);
        setClassroomAccessToken(null);
        await revokeToken(user);
        setLoadingClassroom(false);

        localStorage.removeItem("userData");
        localStorage.removeItem("loggedInClassroom");
        await signOut(auth);

        setProfileLoading(false);
    };

    const renderTimetable = day => {
        if (!timetable)
            return <></>;

        let dayTimetable = timetable[day];
        if (!dayTimetable)
            return <></>;

        let isLast = index => index === Object.keys(dayTimetable).length - 1;
        let isDone = lesson => parseInt(lesson.endTime.split(":")[0]) < (new Date()).getHours() || (parseInt(lesson.endTime.split(":")[0]) === (new Date()).getHours() && parseInt(lesson.endTime.split(":")[1]) < (new Date()).getMinutes());

        return <div className={ style.timetable }>
            <div className={ style.progress }>
                { Object.values(dayTimetable).map((lesson, index) => <span key={ `timetableEdit-progress-${index}` } className={ [style.classIndicator, isLast(index) && style.last, isDone(lesson) && style.done].join(" ") }>
                    { isDone(lesson) && <img src={ icons.check_icon }></img> }
                </span>) }
            </div>
            <div className={ style.timetableContent }>
                { Object.values(dayTimetable).map((lesson, index) => <div key={ `timetableEdit-content-${index}` } className={ style.class } /*onClick={ () => editTimetableClass(lesson) }*/>
                    <section className={ style.classHeader }>
                        <img className={ style.timetableSubjectIcon } src={ icons[getSubjectIcon(lesson.subjectTitle)] }></img>
                        <h4 className={ style.timetableSubject }>{ lesson.subjectTitle }</h4>
                        <img className={ style.timetableDeleteIcon } src={ icons.trash_icon } onClick={ () => setDeleteTimetableClassModal({ show: true, timetableClass: lesson.startTime }) }></img>
                    </section>
                    <section className={ style.classBottom }>
                        <img src={ icons.clock_orange_icon }></img>
                        <h5 className={ style.time }>{ lesson.startTime }-{ lesson.endTime }</h5>
                    </section>
                </div>) }
            </div>
        </div>;
    };

    /*useEffect(() => {
        if (!user || props.page !== "profile")
            return;

        if (!updatingProfile.rendered) {
            updatingProfile.rendered = true;
            return;
        }

        // TODO: Save button
        updatingProfile = { changed: email !== user.email || username !== user.username || (profilePic || undefined) !== user.profilePicture, lastTyped: (new Date()).getTime() };        
        clearTimeout(updateProfileTimeout);

        updateProfileTimeout = setTimeout(async () => {
            if (updatingProfile.changed && (new Date()).getTime() - updatingProfile.lastTyped >= 2000) {
                const newUser = { ...user, email, username, profilePic: profilePic || "" };

                if (!username) {
                    setError({ show: true, error: "Inserisci un nome utente!" });
                    return;
                }
        
                if (user.email !== email) {
                    try {
                        await verifyBeforeUpdateEmail(auth.currentUser, user.email);
                        await updateDoc(doc(db, "users", user.id), { emailVerified: false, updatingEmail: true });
                        window.location.href = "/emailVerification";
                    } catch (err) {
                        console.warn(err);
                        // setReauthentication({ showModal: true });
                    };
        
                    return;
                }
                
                setError({ show: true, error: "Aggiornamento delle impostazioni...", loading: true });
                await setDoc(doc(db, "users", user.id), newUser);
                setUser(newUser);
                setTimeout(() => setError({ show: true, error: "Impostazioni aggiornate" }), 250);
            }
        }, 2000);

        return () => clearTimeout(updateProfileTimeout);
    }, [email, username, profilePic]);*/

    const setProfilePopupReAuthenticate = () => {
        setProfilePopup({ 
            show: true, 
            text: "Stai modificando dei dati sensibili, questa azione richiede che il login sia rieffettuato", 
            icon: icons.warning_icon, 
            buttons: <>
                <IconButton text="LOGOUT" loading={ profileLoading } icon={ icons.logout_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "2rem", padding: ".5rem 0" }} onClick={ logout }/>
                <IconButton text="ANNULLA" loading={ profileLoading } icon={ icons.arrow_left_icon } iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "1rem", padding: ".5rem 0" }} onClick={ () => {
                    if (!profileLoading)
                        setProfilePopup({ show: false, icon: null, text: "", buttons: null }) 
                } } />
            </>
        });
    };

    const saveProfile = async () => {
        if (profileLoading)
            return;

        setProfileLoading(true);
        setError({ show: true, error: "Aggiornamento delle impostazioni...", loading: true });

        const newUser = { ...user, email, username, profilePicture: profilePic || "" };
        if (!username) {
            setError({ show: true, error: "Inserisci un nome utente!" });
            return;
        }

        if (user.email !== email) {
            try {
                await verifyBeforeUpdateEmail(auth.currentUser, user.email);
                await updateDoc(doc(db, "users", user.id), { emailVerified: false, updatingEmail: true });
                window.location.href = "/emailVerification";
            } catch (err) {
                console.warn(err);
                setProfilePopupReAuthenticate();
            };

            return;
        }
        
        await setDoc(doc(db, "users", user.id), newUser);
        setUser(newUser);
        setError({ show: true, error: "Impostazioni aggiornate" });
        setProfileLoading(false);
    };

    const cancelStripeSubscription = async (redirect = true) => {
        const res = await fetch(urls.cancelPremiumSubscription, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: user.email,
                subscriptionId: user.stripeSubscriptionId
            })
        });
        
        if (!redirect) 
            return;

        if (res.ok) 
            setPage({ page: "stripeHandler", action: "cancel", status: true });
        else
            setPage({ page: "stripeHandler", action: "cancel", status: false });
    };

    const handleStripeSubmit = async (create=true) => {
        setGeneratingStripeCheckout(true);
        const res = await fetch(create ? urls.createCheckoutSession : urls.createPortalSession, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                customer_email: user.email,
                session_id: create ? undefined : user.stripeSessionId
            })
        });
    
        window.location.href = (await res.json()).url
    };

    const deleteAccount = async () => {
        const removeAccount = async () => {
            if (profilePopup.loading)
                return;

            setProfilePopup(oldProfilePopup => ({ ...oldProfilePopup, loading: true }));
            const oldUser = { ...user };

            try {
                await deleteDoc(doc(db, "users", user.id));
                await deleteUser(auth.currentUser);
                if (user?.premium) await cancelStripeSubscription();

                setLoadingClassroom(true);
                setClassroomAccessToken(null);
                await revokeToken(user);
                setLoadingClassroom(false);
                localStorage.removeItem("userData");
                localStorage.removeItem("loggedInClassroom");
            } catch (err) {
                await setDoc(doc(db, "users", oldUser.id), oldUser);
                console.warn("Error deleting account:", err);
                setProfilePopupReAuthenticate();
            }

            setProfilePopup(oldProfilePopup => ({ ...oldProfilePopup, loading: false }));
        }

        setProfilePopup({
            show: true,
            text: "Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile", 
            icon: icons.warning_icon, 
            loading: false,
            buttons: <>
                <IconButton loading={ profilePopup.loading } text="ELIMINA" icon={ icons.trash_white_icon } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "2rem", padding: ".5rem 0" }} onClick={ removeAccount }/>
                <IconButton loading={ profilePopup.loading } text="ANNULLA" icon={ icons.arrow_left_icon } iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "1rem", padding: ".5rem 0" }} onClick={ () => { 
                    if (!profilePopup.loading)
                        setProfilePopup({ show: false, loading: false, icon: null, text: "", buttons: null })
                } } />
            </>
        });
    };

    const changePassword = async () => {
        const editPassword = async () => {
            if (profilePopup.loading)
                return;

            setProfilePopup(oldProfilePopup => ({ ...oldProfilePopup, loading: true }));   

            try {
                await updatePassword(auth.currentUser, profilePopup.newPassword);
                setError({ error: "Password modificata con successo", show: true });
                setProfilePopup({ show: false, loading: false, icon: null, text: "", buttons: null })
            } catch (err) {
                console.warn("Error changing password:", err);
                setProfilePopupReAuthenticate();
                setProfilePopup(oldProfilePopup => ({ ...oldProfilePopup, loading: false }));   
            }
        }

        setProfilePopup({
            show: true,
            text: "Modifica la password per il tuo account", 
            icon: icons.warning_icon, 
            buttons: <>
                <input placeholder="Nuova password" type="password" value={ profilePopup.newPassword } onChange={ event => setProfilePopup(oldProfilePopup => ({ ...oldProfilePopup, newPassword: event.target.value })) }></input>
                <IconButton loading={ profilePopup.loading } text="CONFERMA" icon={ icons.check_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "2rem", padding: ".5rem 0" }} onClick={ editPassword }/>
                <IconButton loading={ profilePopup.loading } text="ANNULLA" icon={ icons.arrow_left_icon } iconDimensions="2rem" fontSize="1rem" style={{ marginTop: "1rem", padding: ".5rem 0" }} onClick={ () => { 
                    if (!profilePopup.loading)
                        setProfilePopup({ show: false, loading: false, icon: null, text: "", buttons: null })
                } } />
            </>
        });
    };

    const searchSubjects = async () => {
        if (!user)
            return;

        setSearchingSubjects(true);

        try {
            const response = await fetch(urls.getSubjects, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ user })
            });

            const foundSubjects = await response.json();
            const newSubjects = {};

            Object.values(foundSubjects).forEach(async subject => {
                const subjectName = subject["miur:DISCIPLINA"][0] + subject["miur:DISCIPLINA"].substring(1).toLowerCase();
                newSubjects[subjectName] = {
                    subject: subjectName,
                    icon: getIconBySubjectName(subjectName.toLowerCase())[0]?.[0]?.[0]
                };
                await setDoc(doc(db, `schools/${user.school}/classes/${user.class}/subjects`, subjectName), newSubjects[subjectName]);
            });

            setSubjects(oldSubjects => ({ ...oldSubjects, ...newSubjects }));
        } catch (err) {
            console.warn(`Error fetching possible subjects: ${err}`);
            setError({ show: true, error: "Qualcosa non ha funzionato, riprova" });
        }

        setSearchingSubjects(false);
    };

    const saveClassroomSubject = async courseSubject => {
        if (!user || !subjects)
            return;

        setClassroomSubjectPopup(oldPopup => ({ ...oldPopup, loading: true }));

        const selectedSubject = Object.values(subjects).filter(subject => subject.subject === courseSubject)?.[0];
        await updateDoc(doc(db, "users", user.id), {
            ["classroomSubjects." + classroomSubjectPopup.course.id]: selectedSubject?.subject ?? false
        });

        setUser(oldUser => ({ ...oldUser, classroomSubjects: { ...oldUser.classroomSubjects, [classroomSubjectPopup.course.id]: selectedSubject?.subject ?? false } }));
        setClassroomSubjectPopup({ show: false, subject: null, course: null });
    };

    const saveRegisterSubject = async courseSubject => {
        if (!user || !subjects)
            return;

        setRegisterSubjectPopup(oldPopup => ({ ...oldPopup, loading: true }));

        const selectedSubject = Object.values(subjects).filter(subject => subject.subject === courseSubject)?.[0];
        await updateDoc(doc(db, "users", user.id), {
            ["registerSubjects." + registerSubjectPopup.course.id]: selectedSubject?.subject ?? false
        });

        setUser(oldUser => ({ ...oldUser, registerSubjects: { ...oldUser.registerSubjects, [registerSubjectPopup.course.id]: selectedSubject?.subject ?? false } }));
        setRegisterSubjectPopup({ show: false, subject: null, course: null });

    }

    const generateCalendar = () => {
        if (window.Worker) {
            const worker = new Worker(`${process.env.PUBLIC_URL}/workers/functions.js`);
            worker.onmessage = response => {
                setCalendar(response.data);
                worker.terminate();
            };
            worker.postMessage({ query: constants.WORKER_QUERIES.GENERATE_CALENDAR });

            return;
        }

        const now = new Date();
        let date = new Date(now.getFullYear() - 1, 0, 1);
        let weeks = [];
        let week = -1;

        while (date.getDay() !== 1)
            date = addDays(date, 1);

        while (date.getFullYear() <= now.getFullYear() + 1) {
            if (date.getDay() === 1)
                week += 1;

            if (!weeks[week])
                weeks.push([]);

            weeks[week].push(date);
            date = addDays(date, 1);
        }

        setCalendar(weeks);
        return weeks;
    };

    const compareDates = (firstDate, secondDate, strict=false) => {
        if (!firstDate || !secondDate) 
            return false;

        if (strict)
            return firstDate.getTime() === secondDate.getTime();
        
        return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
    };

    useEffect(() => {
        if (user) {
            setEmail(user.email);
            setUsername(user.username);
            setProfilePic(user.profilePicture);
        }
    }, [user]);

    useEffect(() => {
        if (props.page === "classroom" && classroomAccessToken && user) {
            setLoadingClassroom(false);
            const getClassroomCourses = async () => setClassroomCourses(await getCourses(user));
            getClassroomCourses();
        }
    }, [props.page, user, classroomAccessToken]);

    useEffect(() => {
        const authenticate = async () => {
            setLoadingClassroom(true);
            const loggedIn = await isLoggedIn(user);
            if (!loggedIn) {
                setLoadingClassroom(false);
                return;
            }
            
            const token = await authenticateClassroomAPI(user);
            setClassroomAccessToken(token);
            setLoadingClassroom(false);
        };

        if (props.page === "classroom" && user && !classroomAccessToken) 
            authenticate();
    }, [props.page, user, classroomAccessToken]);

    useEffect(() => {
        let unsubscribe;
        
        const fetchData = async () => {
            setSchoolLists(Object.fromEntries((await getDocs(query(collection(db, `schools/${user.school}/presidentsLists`)))).docs.map(doc => [doc.id, doc.data()])));
            
            unsubscribe = onSnapshot(doc(db, `schools/${user.school}`), snapshot => {
                const data = snapshot.data().presidents;
                setSchoolPresidentsData(data);
                setSchoolPresidents(data);
                Object.entries(data ?? {}).forEach(([candidate, votes]) => {
                    if (candidate !== "winners" && votes.includes(user.id))
                        setVotedSchoolPresidents(oldVotes => ([ ...oldVotes, candidate ]));
                });
            });

            if (user.schoolPresidentList)
                setSchoolList((await getDoc(doc(db, `schools/${user.school}/presidentsLists/${user.schoolPresidentList}`))).data());

            return unsubscribe;
        };

        if (props.page === "school") {
            fetchData();
            return unsubscribe;
        }
    }, [props.page]);

    useEffect(() => {
        if (props.page === "calendar")
            generateCalendar();
    }, [props.page]);

    useEffect(() => {
        if (calendar) {
            const today = new Date();
            calendar.forEach(week => week.forEach(day => {
                if (day.getDate() === today.getDate() && day.getMonth() === today.getMonth() && day.getFullYear() === today.getFullYear()) {
                    setCalendarActiveSlide(calendar.indexOf(week));
                    swiper.current?.swiper?.slideTo(calendar.indexOf(week));
                }
            }));
        }
    }, [calendar, swiperLoaded, props.option]);

    return <main className={ style.main } style={{         
        transitionProperty: !props.selected ? "width, height, top, left, opacity" : "width, height, top, left",
        minHeight: props.selected ? "105vh" : "1vh",
        height: props.selected ? "105vh" : "1vh",
        width: props.selected ? "100vw" : "1vw",
        top: props.selected ? "0" : props.top,
        left: props.selected ? "0" : props.left,
        opacity: props.selected ? "1" : "0",
        ...props.style
    }} onScroll={ e => {
        const scroll = e.target.scrollTop;

        if (scroll > 0 && prevScroll === 0) {
            setShrink(true);
            prevScrollTime = e.timeStamp;
        } else if (e.timeStamp - prevScrollTime > 100 && scroll === 0) setShrink(false);

        prevScroll = scroll;
    } }>
        {/* { props.page === "profile" ? <>
            <section className={ style.pageTopSection } style={{ position: "sticky", top: "0", marginTop: "0", paddingBottom: "0", height: !shrink && "30vh", backgroundColor: "transparent", backgroundImage: `url(${icons.discord_icon})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>           
                <div className={ style.flex } style={{ transition: "margin .1s ease", marginTop: "1rem" }}>
                    <img src={ icons.arrow_left_icon } style={{ background: "rgba(84, 84, 84, .5)", border: "none", paddingLeft: ".25rem", paddingRight: ".25rem" }} className={ style.backIcon } onClick={ props.hide }></img>
                    <h2 className={ style.pageHeader } style={{ background: "rgba(84, 84, 84, .5)", borderRadius: ".5rem", maxWidth: "fit-content", padding: ".5rem 1rem", fontSize: "1rem" }}>Profilo</h2>
                </div>
            </section>
        </> : 
            <section className={ style.pageTopSection }>
                <div className={ style.decoration }></div>
                <div className={ style.flex }>
                    <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.hide }></img>
                    <h2 className={ style.pageHeader }>{ props.title }</h2>
                </div>
            </section> 
        } */}
        <section className={ style.pageTopSection } style={{ position: "sticky", top: "0", marginTop: "0", paddingBottom: "0",  /* backgroundColor: props.page === "profile" && "transparent", backgroundImage: props.page === "profile" && `url(${user?.profilePicture || `https://eu.ui-avatars.com/api/?name=${user?.username}&background=d86c07&format=svg&color=fff`})`, backgroundPosition: props.page === "profile" &&"center", backgroundRepeat: props.page === "profile" && "no-repeat", backgroundSize: props.page === "profile" && "cover" */ }}>
            { /* props.page !== "profile" && */ <div className={ style.decoration }></div> }
            <div className={ style.flex } style={{ transition: "margin .1s ease", marginTop: "1rem" }}>
                <img src={ icons.arrow_left_icon } style={{ background: "rgba(84, 84, 84, .5)", border: "none", paddingLeft: ".25rem", paddingRight: ".25rem" }} className={ style.backIcon } onClick={ e => {
                    e.preventDefault();
                    e.nativeEvent.stopImmediatePropagation();
                    e.stopPropagation();

                    if (page.subPage) {
                        setPage({ page: "timetableAdd", subPage: null });
                        return;
                    }
                    switch (page.page) {
                        case "subjectsAdd":
                            setPage({ page: null });
                            setNewSubject({ name: "", icon: null, saving: false });
                            setTitle("Materie");
                            break;
                        case "timetableAdd":
                            setPage({ page: null });
                            setTitle("Orario")
                            break;
                        case "joinList":
                            setPage({ page: null });
                            setTitle("Il tuo istituto");
                            break;
                        case "newList":
                            setPage({ page: null });
                            setTitle("Il tuo istituto");
                            break;
                        default:
                            props.hide(e);
                            break;
                    }
                } }></img>
                <h2 className={ style.pageHeader } style={{ background: "rgba(84, 84, 84, .5)", borderRadius: ".5rem", maxWidth: "fit-content", padding: ".5rem 1rem", fontSize: "1rem" }}>{ title }</h2>
                { ((props.page === "subjects" && page.page !== "subjectsAdd") || props.page === "timetable" && page.page !== "timetableAdd") && <img src={ icons.add_orange_icon } className={ style.addSubjectIcon } onClick={ () => {
                    switch (props.page) {
                        case "subjects":
                            setPage({ page: "subjectsAdd" });
                            setTitle("Nuova materia");
                            return;
                        case "timetable":
                            setPage({ page: "timetableAdd" });
                            setTitle("Nuova ora");
                            return;
                    }
                } }></img> }
            </div>
        </section>
        <ErrorSnackbar error={ error.error } show={ error.show } loading={ error.loading } setShow={ show => setError(oldError => ({ ...oldError, show })) } />
        { (() => {
            switch (props.page) {
                case "profile":
                    return <>
                        <Banner id="profile" style={{ marginTop: "1rem" }} />
                        <Popup show={ profilePopup.show } icon={ profilePopup.icon } text={ profilePopup.text } buttons={ profilePopup.buttons } />
                        <h3 className={ style.sectionHeader }>Impostazioni utente</h3>
                        <div className={ style.inputContainer } style={{ marginTop: "2rem" }}>      
                            <input required placeholder=" " type="email" className={ style.input } value={ email } onChange={ e => setEmail(e.target.value) }></input>
                            <span className={ style.highlight }></span>
                            <span className={ style.bar }></span>
                            <label className={ style.label }>Email</label>
                        </div>
                        <div className={ style.inputContainer } style={{ marginTop: "1.25rem" }}>      
                            <input required placeholder=" " type="text" className={ style.input } value={ username } onChange={ e => setUsername(e.target.value) }></input>
                            <span className={ style.highlight }></span>
                            <span className={ style.bar }></span>
                            <label className={ style.label }>Nome utente</label>
                        </div>
                        <div className={ style.inputContainer } style={{ marginTop: "1.25rem" }}>      
                            <input required placeholder=" " type="text" pattern="https://.*" className={ style.input } value={ profilePic } onChange={ e => setProfilePic(e.target.value) }></input>
                            <span className={ style.highlight }></span>
                            <span className={ style.bar }></span>
                            <label className={ style.label }>Link foto profilo</label>
                        </div>
                        <IconButton text="SALVA MODIFICHE" loading={ profileLoading } icon={ icons.check_icon } iconDimensions="2rem" fontSize=".8rem" style={{ marginTop: "2rem", marginLeft: "auto", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ saveProfile } />
                        <IconButton text="LOGOUT" loading={ profileLoading }  icon={ icons.logout_white_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="1.75rem" fontSize=".8rem" style={{ marginTop: "1.5rem", marginLeft: "auto", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ logout } />
                        { user?.providerId !== "google.com" && <IconButton text="MODIFICA PASSWORD" loading={ profileLoading } icon={ icons.lock_white_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="1.75rem" fontSize=".8rem" style={{ marginTop: "1.5rem", marginLeft: "auto", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ changePassword } /> }
                        <IconButton text="ELIMINA ACCOUNT" loading={ profileLoading } icon={ icons.trash_white_icon } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0))" iconDimensions="1.75rem" fontSize=".8rem" style={{ marginTop: "1.5rem", marginLeft: "auto", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ deleteAccount } />
                        {/* <h3 className={ style.sectionHeader }>I tuoi badge</h3> */}
                        <h3 className={ style.sectionHeader }>Altro</h3>
                        <IconButton text="Torna alla presentazione" icon={ icons.logo_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="1.75rem" fontSize=".8rem" style={{ marginTop: "1.5rem", marginLeft: "auto", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ () => {
                            localStorage.removeItem("appTourDone");
                            window.location.href = "/";
                        } } />
                        <IconButton text="Rivedi le ultime novità" icon={ icons.double_arrow_left } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" iconDimensions="1.75rem" fontSize=".8rem" style={{ marginTop: "1.5rem", marginLeft: "auto", marginBottom: "5rem", marginRight: "auto", padding: ".75rem 1rem" }} width="75%" onClick={ () => {
                            localStorage.removeItem("appVersion");
                            localStorage.removeItem("latestFeatureSeen");
                            window.location.href = "/";
                        } } />
                    </>;
                case "notifications":
                    return <section style={{ marginBottom: "1rem" }}>
                        <Banner id="notifications" style={{ marginTop: "1rem" }} />
                        { getOS() === "iOS" && <div className={ style.iOSWarning }>
                            <img src={ icons.apple_icon } className={ style.iOSWarningIcon }></img>
                            <h4 className={ style.iOSWarningText }>I telefoni Apple non supportano ancora le notifiche push. Puoi comunque scegliere di ricevere le notifiche via mail</h4>
                        </div> }
                        { getOS() === "iOS" && <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.email_orange_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Via mail</h4>
                                <Switch active={ user?.notificateEmail } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateEmail: !user.notificateEmail }));
                                    await updateDoc(doc(db, "users", user.id), { notificateEmail: !user.notificateEmail });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi le notifiche via email</h5>
                        </div> }
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.notification_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Un giorno prima</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateDayBefore } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateDayBefore: !user.notificateDayBefore }));
                                    await updateDoc(doc(db, "users", user.id), { notificateDayBefore: !user.notificateDayBefore });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica per ogni evento un giorno esatto prima della scadenza</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.notification_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>La mattina del giorno prima</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateMorningDayBefore } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateMorningDayBefore: !user.notificateMorningDayBefore }));
                                    await updateDoc(doc(db, "users", user.id), { notificateMorningDayBefore: !user.notificateMorningDayBefore });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica per ogni evento alla prima ora del giorno precedente</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.notification_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>La mattina stessa</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateMorningDate } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateMorningDate: !user.notificateMorningDate }));
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica per ogni evento alla prima ora del giorno stesso</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.notification_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Per ogni nuovo evento</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateOnAddEvent } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateOnAddEvent: !user.notificateOnAddEvent }));
                                    await updateDoc(doc(db, "users", user.id), { notificateOnAddEvent: !user.notificateOnAddEvent });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica per ogni evento che viene aggiunto da un tuo compagno di classe</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.notification_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Per il giorno dopo</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateSummarizeNextDayEvents } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateSummarizeNextDayEvents: !user.notificateSummarizeNextDayEvents }));
                                    await updateDoc(doc(db, "users", user.id), { notificateSummarizeNextDayEvents: !user.notificateSummarizeNextDayEvents });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica ogni giorno alla fine dell'ultima ora con un riepilogo di tutti gli impegni per il giorno successivo</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.announcement_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Rappresentanti di classe</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateClassPresidentAnnouncements } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateClassPresidentAnnouncements: !user.notificateClassPresidentAnnouncements }));
                                    await updateDoc(doc(db, "users", user.id), { notificateClassPresidentAnnouncements: !user.notificateClassPresidentAnnouncements });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica ogni volta che i rappresentanti di classe creano un annuncio</h5>
                        </div>
                        <div className={ style.notificationOption }>
                            <div>
                                <img src={ icons.announcement_icon } className={ style.notificationOptionIcon }></img>
                                <h4 className={ style.notificationOptionTitle }>Rappresentanti di istituto</h4>
                                <Switch disabled={ getOS() === "iOS" && !user?.notificateEmail } active={ user?.notificateSchoolPresidentAnnouncements } onChange={ async () => {
                                    setUser(oldUser => ({ ...oldUser, notificateSchoolPresidentAnnouncements: !user.notificateSchoolPresidentAnnouncements }));
                                    await updateDoc(doc(db, "users", user.id), { notificateSchoolPresidentAnnouncements: !user.notificateSchoolPresidentAnnouncements });
                                } } width="12.5vw" height="3vh" />
                            </div>
                            <h5 className={ style.notificationOptionDescription }>Ricevi una notifica ogni volta che i rappresentanti di istituto creano un annuncio</h5>
                        </div>
                    </section>;
                case "bugReport":
                    return <section>
                        <Banner id="bugReport" style={{ marginTop: "1rem" }} />
                        <textarea className={ style.bugReport } value={ bugReport.text } onChange={ e => setBugReport({ text: e.target.value }) }></textarea>
                        <IconButton loading={ bugReport.sending } text="INVIA" icon={ icons.send_white_icon } style={{ marginLeft: "auto", marginRight: "auto", width: "70%", padding: ".75rem .5rem" }} textStyle={{ marginLeft: "auto", marginRight: "auto", marginTop: "auto", marginBottom: "auto" }} fontSize=".9rem"
                            onClick={ () => {
                                setBugReport({ ...bugReport, sending: true })
                                fetch("https://schooldiary.asvirtual.repl.co/api/report", {     
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ user, text: bugReport.text }),
                                }).then(res => setBugReport({ sending: false, text: "" }))
                                .catch(err => setBugReport({ sending: false, text: "" }));
                            } } />
                    </section>;
                case "betaTester":
                    return <section>
                        <Banner id="betaTester" style={{ marginTop: "1rem" }} />
                        {
                            user.betaTester ? <>
                                <h3 className={ style.sectionHeader }>Sei un beta tester!</h3>
                                <Lottie 
                                    style={{ marginTop: "2rem", marginLeft: "auto", marginRight: "auto", width: "65vw" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ brainstorming_animation }
                                />
                                <h4 style={{ marginLeft: "1rem", marginRight: "1rem", fontSize: ".9rem" }}>Grazie per il tuo aiuto per migliorare <span style={{ color: "var(--orange)" }} >SchoolDiary</span>!<br></br><br></br><a href="https://beta--school-diary-app.netlify.app/" target="_blank" style={{ color: "white", textDecoration: "none" }}>Clicca <span style={{ color: "var(--orange)" }}>qui</span> per scaricare la versione di <span style={{ color: "var(--orange)" }}>SchoolDiary beta</span></a></h4>
                                <IconButton background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" text="ABBANDONA" icon={ icons.logout_white_icon } style={{ marginLeft: "auto", marginRight: "auto", width: "70%", padding: "1rem .5rem" }} textStyle={{ marginLeft: "auto", marginRight: "auto", marginTop: "auto", marginBottom: "auto" }} fontSize=".9rem"
                                    onClick={ async () => {
                                        await updateDoc(doc(db, `users`, user.id), { betaTester: false });
                                        setUser(oldUser => ({ ...oldUser, betaTester: false }))
                                    } } />
                            </> : <>
                                <h3 className={ style.sectionHeader }>Diventa un beta tester</h3>
                                <Lottie 
                                    style={{ marginTop: "2rem", marginLeft: "auto", marginRight: "auto", width: "65vw" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ brainstorming_animation }
                                />
                                <h4 style={{ marginLeft: "1rem", marginRight: "1rem", fontSize: ".9rem" }}>Aiutaci a migliorare l'app, ottieni accesso alla versione sperimentale di <span>SchoolDiary</span> per testare in anticipo le novità!<br></br><br></br>Ti manderemo presto un'email con i dettagli e se ci aiuterai ti ricompenseremo con un iscrizione gratuita al piano premium!</h4>
                                <IconButton text="DIVENTA UN TESTER" icon={ icons.send_white_icon } style={{ marginLeft: "auto", marginRight: "auto", width: "70%", padding: "1rem .5rem" }} textStyle={{ marginLeft: "auto", marginRight: "auto", marginTop: "auto", marginBottom: "auto" }} fontSize=".9rem"
                                    onClick={ async () => {
                                        await updateDoc(doc(db, `users`, user.id), { betaTester: true });
                                        setUser(oldUser => ({ ...oldUser, betaTester: true }));
                                        await fetch(`${urls.betaTester}?user=${user.id}`)
                                    } } />
                            </>
                        }
                    </section>;
                case "subjects":
                    return <>
                        <Banner id="subjects" style={{ marginTop: "1rem" }} />
                        <section className={ style.subjectsAdd } style={{ height: page.page === "subjectsAdd" && "100%" }}>                        
                            <div className={ style.inputContainer } style={{ marginTop: "2rem" }}>      
                                <input required placeholder=" " type="text" className={ style.input } value={ newSubject.name } onChange={ e => setNewSubject(oldNewSubject => ({ ...oldNewSubject, name: e.target.value.length > 1 ? e.target.value[0]?.toUpperCase() + e.target.value?.substring(1) : e.target.value?.toUpperCase() })) }></input>
                                <span className={ style.highlight }></span>
                                <span className={ style.bar }></span>
                                <label className={ style.label }>Nome materia</label>
                            </div>
                            <h3 className={ style.sectionHeader }>Icona</h3>
                            { newSubject.name ? <>
                                <h5 className={ style.sectionSubHeader }>Trovate per "{ newSubject.name }":</h5>
                                <section className={ [style.subjectsIcons, !newSubject.name && style.disabled].join(" ") }>
                                    { getIconBySubjectName()[0].map((icon, index) => <div key={ `icons-match-${index}` } style={{ borderRadius: ".5rem" }} className={ style.subjectsIcon } onClick={ () => setNewSubjectIcon(icon) }><img src={ icons[icon] } style={{ background: icon === newSubject.icon && "rgb(28, 126, 255)" }} ></img></div> )}
                                </section>
                                <h5 className={ style.sectionSubHeader }>Tutte:</h5>
                                <section className={ [style.subjectsIcons, !newSubject.name && style.disabled].join(" ") }>
                                    { getIconBySubjectName()[1].map((icon, index) => <div key={ `icons-not-match-${index}` } className={ style.subjectsIcon } onClick={ () => setNewSubjectIcon(icon) }><img src={ icons[icon] } style={{ background: icon === newSubject.icon && "rgb(28, 126, 255)" }} ></img></div> )}
                                </section>
                            </> : <section className={ [style.subjectsIcons, !newSubject.name && style.disabled].join(" ") }>
                                { getIconBySubjectName()[0].map((icon, index) => <div key={ `icons-match-${index}` } style={{ borderRadius: ".5rem" }} className={ style.subjectsIcon } onClick={ () => setNewSubjectIcon(icon) }><img src={ icons[icon] } style={{ background: icon === newSubject.icon && "rgb(28, 126, 255)" }} ></img></div> )}
                                { getIconBySubjectName()[1].map((icon, index) => <div key={ `icons-not-match-${index}` } className={ style.subjectsIcon } onClick={ () => setNewSubjectIcon(icon) }><img src={ icons[icon] } style={{ background: icon === newSubject.icon && "rgb(28, 126, 255)" }} ></img></div> )}
                            </section> }
                            <IconButton loading={ newSubject.saving } text="SALVA" icon={ icons.check_icon } style={{ marginTop: "2rem", marginBottom: "3rem", paddingTop: ".5rem", paddingBottom: ".5rem" }} textStyle={{ margin: "auto" }} iconDimensions="2rem" fontSize="1rem" onClick={ saveSubject } />
                        </section>
                        <div className={ style.subjects } style={{ height: page.page === "subjectsAdd" && "0" }}>
                            <section className={ style.subjectsGrid } >
                                <Popup show={ deleteSubjectModal.show } text="Sei sicuro di voler eliminare questa materia?" icon={ icons.warning_icon } buttons={ <>
                                    <IconButton icon={ icons.arrow_left_icon } iconDimensions="2rem" text="ANNULLA" fontSize="1rem" style={{ marginTop: "2rem", padding: ".5rem 0" }} onClick={ () => setDeleteSubjectModal({ show: false, subject: null }) } />
                                    <IconButton icon={ icons.trash_white_icon } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" text="ELIMINA" fontSize="1rem" style={{ marginTop: "1rem", padding: ".5rem 0" }} loading={ deleteSubjectModal.loading } onClick={ deleteSubject } />
                                </> } />
                                { subjects && Object.values(subjects).map(subject => <div key={ `subjectAdd-${subject.subject}` } className={ style.subjectContainer } onClick={ () => editSubject(subject) }>
                                    <div className={ style.subject }>
                                        <img src={ icons[subject.icon] } className={ style.subjectIcon }></img>
                                        {/* <img src={ icons.edit_icon } className={ style.subjectActionIcon } onClick={ () => {} } style={{ right: "2rem", width: "1rem" }}></img> */}
                                        <img src={ icons.trash_icon } className={ style.subjectActionIcon } onClick={ e => {
                                            e.stopPropagation();
                                            setDeleteSubjectModal({ show: true, subject: subject.subject });
                                        } }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>{ subject.subject }</h6>
                                </div>) }
                                {/* <div className={ style.subjectContainer } onClick={ () => editSubject(0) }>
                                    <div className={ style.subject }>
                                        <img src={ icons.physics_icon } className={ style.subjectIcon }></img>
                                        <img src={ icons.trash_icon } className={ style.subjectActionIcon } onClick={ e => {
                                            e.stopPropagation();
                                            setDeleteSubjectModal({ show: true, subject: "Fisica" });
                                        } }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>Fisica</h6>
                                </div> */}
                            </section>
                            <IconButton icon={ icons.search_white_icon } text="TROVA MATERIE" fontSize="1rem" style={{ marginTop: "1rem", marginBottom: "2rem", padding: ".5rem 0" }} loading={ searchingSubjects } onClick={ searchSubjects } />
                        </div>
                    </>;                            
                case "timetable":
                    return <>
                        <Banner id="timetable" style={{ marginTop: "1rem" }} />
                        <section className={ style.timetableAddSubjectPage } style={{ height: page.subPage === "chooseSubject" && "100%" }}> 
                            <h2 style={{ fontSize: "1.2rem", marginBottom: "0",marginLeft: "1rem" }}>Scegli la <span style={{ color: "var(--orange)" }}>materia</span></h2>
                            {/* <h3 style={{ fontSize: ".8rem", marginTop: ".25rem", marginLeft: "1rem", marginBottom: "1rem", color: "rgb(145, 143, 143)" }} className={ style.subHeader }>O aggiungine una nuova</h3>                            */}
                            <div className={ style.timetableAddSubjects }>
                                { subjects && Object.values(subjects).map(subject => <div key={ `timetable-${subject.subject}` } className={ style.timetableAddSubject } onClick={ () => {
                                    setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, subject: subject.subject }));
                                    setPage(oldPage => ({ ...oldPage, subPage: null }));
                                } }>
                                    <img src={ icons[subject.icon] } className={ style.timetableAddSubjectIcon }></img>
                                    <h3 className={ style.timetableAddSubjectName }>{ subject.subject }</h3>
                                </div>) }
                                {/* <div className={ style.timetableAddSubject }>
                                    <img src={ icons.physics_icon } className={ style.timetableAddSubjectIcon }></img>
                                    <h3 className={ style.timetableAddSubjectName }>Fisica</h3>
                                </div> */}
                            </div>
                        </section>
                        <section className={ style.timetableAdd } style={{ height: page.page === "timetableAdd" && !page.subPage && "100%" }} onClick={ e => {
                            e.preventDefault();
                            setShowTimePicker({ startHour: false, endHour: false });
                        } }>
                            <div className={ style.detailsContainer }>
                                <div className={ style.detail } onClick={ () => setPage(oldPage => ({ ...oldPage, subPage: "chooseSubject" })) }>
                                    <img src={ icons[getSubjectIcon(newTimetableClass.subject)] }></img>
                                    <div>
                                        <h4 className={ style.detailName }>Materia</h4>
                                        <h4 className={ style.detailValue }>{ newTimetableClass.subject || "Scegli" }</h4>
                                    </div>
                                </div>
                                <div className={ style.detail } onClick={ e => {
                                    e.stopPropagation();
                                    setShowTimePicker(oldShowTimePicker => ({ startHour: !oldShowTimePicker.startHour }));
                                } }>
                                    <img src={ icons.clock_orange_icon }></img>
                                    <div>
                                        <h4 className={ style.detailName }>Inizio</h4>
                                        <h4 className={ style.detailValue }>{ newTimetableClass.startHour }</h4>
                                    </div>
                                    <div className={ style.flex }>
                                        <div className={ style.durationSelect } style={{ height: showTimePicker.startHour && "25vh", right: "50%", borderTopRightRadius: "0", borderBottomRightRadius: "0" }} onClick={ e => e.stopPropagation() }>
                                            { [...Array(24).keys()].map(hour => <div key={ `hour-${hour}` } style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0" }} className={ [style.durationOption, parseInt(newTimetableClass.startHour.split(":")[0]) === hour && style.selected].join(" ") } onClick={ () => {
                                                setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, startHour: `${prettifyDate(hour)}:${oldNewTimetableClass.startHour.split(":")[1]}`, endHour: `${prettifyDate(hour+1)}:${oldNewTimetableClass.startHour.split(":")[1]}` }))
                                            } }><h3>{ prettifyDate(hour) }</h3></div>) }
                                        </div>
                                        <div className={ style.durationSelect } style={{ height: showTimePicker.startHour && "25vh", right: "0", borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} onClick={ e => e.stopPropagation() }>
                                            { [...Array(60).keys()].map(minute => <div key={ `minute-${minute} `} style={{ borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} className={ [style.durationOption, parseInt(newTimetableClass.startHour.split(":")[1]) === minute && style.selected].join(" ") } onClick={ () => {
                                                setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, startHour: `${oldNewTimetableClass.startHour.split(":")[0]}:${prettifyDate(minute)}` }));
                                            } }><h3>{ prettifyDate(minute) }</h3></div>) }
                                        </div>
                                    </div>
                                </div>
                                <div className={ style.detail } onClick={ e => {
                                    e.stopPropagation();
                                    setShowTimePicker(oldShowTimePicker => ({ endHour: !oldShowTimePicker.endHour }));
                                } }>
                                    <img src={ icons.clock_orange_icon }></img>
                                    <div>
                                        <h4 className={ style.detailName }>Fine</h4>
                                        <h4 className={ style.detailValue }>{ newTimetableClass.endHour }</h4>
                                    </div>
                                    <div className={ style.flex }>
                                        <div className={ style.durationSelect } style={{ height: showTimePicker.endHour && "25vh", right: "50%", borderTopRightRadius: "0", borderBottomRightRadius: "0" }} onClick={ e => e.stopPropagation() }>
                                            { [...Array(24).keys()].map(hour => <div key={ `hour-${hour}` } style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0" }} className={ [style.durationOption, parseInt(newTimetableClass.endHour.split(":")[0]) === hour && style.selected].join(" ") } onClick={ () => {
                                                setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, endHour: `${prettifyDate(hour)}:${oldNewTimetableClass.endHour.split(":")[1]}` }))
                                            } }><h3>{ prettifyDate(hour) }</h3></div>) }
                                        </div>
                                        <div className={ style.durationSelect } style={{ height: showTimePicker.endHour && "25vh", right: "0", borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} onClick={ e => e.stopPropagation() }>
                                            { [...Array(60).keys()].map(minute => <div key={ `minute-${minute} `} style={{ borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} className={ [style.durationOption, parseInt(newTimetableClass.endHour.split(":")[1]) === minute && style.selected].join(" ") } onClick={ () => {
                                                setNewTimetableClass(oldNewTimetableClass => ({ ...oldNewTimetableClass, endHour: `${oldNewTimetableClass.endHour.split(":")[0]}:${prettifyDate(minute)}` }))
                                            } }><h3>{ prettifyDate(minute) }</h3></div>) }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <IconButton loading={ newSubject.saving } text="SALVA" icon={ icons.check_icon } style={{ marginTop: "2rem", marginBottom: "3rem", paddingTop: ".5rem", paddingBottom: ".5rem" }} textStyle={{ margin: "auto" }} iconDimensions="2rem" fontSize="1rem" onClick={ saveTimetableClass } />
                        </section>
                        <section style={{ height: page.page === "timetableAdd" ? "0" : "100%", overflowY: "scroll", transition: "height .75s ease" }}>
                            <div className={ style.timetableDays }>                            
                                <div className={ [style.timetableDay, timetableDay === 0 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(0) }>
                                    <h4>L</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 1 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(1) }>
                                    <h4>M</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 2 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(2) }>
                                    <h4>M</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 3 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(3) }>
                                    <h4>G</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 4 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(4) }>
                                    <h4>V</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 5 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(5) }>
                                    <h4>S</h4>
                                </div>
                                <div className={ [style.timetableDay, timetableDay === 6 && style.selected].join(" ") } onClick={ () => swipeTimetablePage(6) }>
                                    <h4>D</h4>
                                </div>
                            </div>
                            <div className={ style.timetables }>
                                <Popup show={ deleteTimetableClassModal.show } text="Sei sicuro di voler eliminare questa ora?" icon={ icons.warning_icon } buttons={ <>
                                    <IconButton icon={ icons.arrow_left_icon } iconDimensions="2rem" text="ANNULLA" fontSize="1rem" style={{ marginTop: "2rem", padding: ".5rem 0" }}  onClick={ () => setDeleteTimetableClassModal({ show: false, timetableClass: null }) } />
                                    <IconButton icon={ icons.trash_white_icon } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" text="ELIMINA" fontSize="1rem" style={{ marginTop: "1rem", padding: ".5rem 0" }} onClick={ () => deleteTimetableClass() } />
                                </> } />
                                <Swiper ref={ timetableSwiper } onSlideChange={ ({ activeIndex }) => setTimetableDay(activeIndex) } style={{ zIndex: "0" }}>
                                    { [...Array(6).keys()].map(day => <SwiperSlide key={ `timetableAdd-${day+1}` }>{ renderTimetable(day + 1) }</SwiperSlide>) }
                                    <SwiperSlide>{ renderTimetable(0) }</SwiperSlide>
                                </Swiper>
                            </div>
                        </section>
                    </>;
                case "school":
                    if (Object.keys(schoolUsers).length === 0)
                        return <section>
                            NO DATA
                        </section>;

                    return <>
                        <Banner id="school" style={{ marginTop: "1rem" }} />
                        <section className={ style.schoolPresidentsList } style={{ height: page.page === "newList" && "100%" }}>
                            <div className={ style.inputContainer } style={{ marginTop: "2rem" }}>      
                                <input required placeholder=" " type="text" className={ style.input } value={ schoolList.name } onChange={ e => updateSchoolList({ name: e.target.value }) }></input>
                                <span className={ style.highlight }></span>
                                <span className={ style.bar }></span>
                                <label className={ style.label }>Nome</label>
                            </div>
                            <div className={ style.inputContainer } style={{ marginTop: "2rem" }}>      
                                <input required placeholder=" " type="url" pattern="https://www.instagram.com/.*" className={ style.input } value={ schoolList.instagramURL } onChange={ e => updateSchoolList({ instagramURL: e.target.value }) }></input>
                                <span className={ style.highlight }></span>
                                <span className={ style.bar }></span>
                                <label className={ style.label }>Link Instagram</label>
                            </div>
                            <TextButton text="Salva" loading={ schoolListLoading } style={{ marginTop: "2rem", width: "70vw", marginLeft: "auto", marginRight: "auto" }} onClick={ async () => {
                                setSchoolListLoading(true);
                                await updateDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`), schoolList);
                                updateSchoolLists({ [schoolList.id]: schoolList });
                                setSchoolListLoading(false);
                                setPage({ page: null });
                            } } />
                            <IconButton icon={ invitingMembersToSchoolList ? icons.test_icon : icons.invite_orange_icon } text={ invitingMembersToSchoolList ? "Lista membri" : "Invita membri" } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" textStyle={{ fontSize: ".8rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ () => setInvitingMembersToSchoolList(oldInvitingMembers => !oldInvitingMembers) } />
                            { (schoolList.members?.length === 1 || schoolList.createdBy !== user.id) && <IconButton icon={ schoolList.members?.length === 1 ? icons.trash_white_icon : icons.logout_white_icon } text={ schoolList.members?.length === 1 ? "ELIMINA" : "ABBANDONA" } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" textStyle={{ fontSize: ".8rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ () => setDeleteSchoolListPopup(true) } />}
                            <Popup onClick={ () => setDeleteSchoolListPopup(false) } show={ deleteSchoolListPopup } text={ schoolList.members?.length === 1 ? "Sei sicuro di voler eliminare questa lista?" : "Sei sicuro di voler abbandonare questa lista?" } icon={ icons.warning_icon } buttons={ <>
                                <TextButton loading={ schoolList.loading } text={ schoolList.members?.length === 1 ? "ELIMINA" : "ABBANDONA" } background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)"  onClick={ async () => {
                                    updateSchoolList({ loading: true });

                                    await updateDoc(doc(db, `users/${user.id}`), { schoolPresidentList: deleteField() })
                                    setUser(oldUser => ({ ...oldUser, schoolPresidentList: null }));
                                    if (schoolList.members?.length === 1)
                                        await deleteDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`));

                                    setSchoolList({});
                                    setDeleteSchoolListPopup(false);
                                    setPage({ page: null });
                                } } />
                                <TextButton text="ANNULLA" style={{ marginTop: "1rem" }} onClick={ () => setDeleteSchoolListPopup(false) } />
                            </> } />
                            <h4 className={ style.infoHeader } style={{ marginTop: "2rem", color: "var(--orange)" }}>Membri</h4>
                            <div className={ style.users } style={{ height: invitingMembersToSchoolList ? "100%" : "0", overflowY: invitingMembersToSchoolList ? "scroll" : "hidden", transition: "height .75s ease" }}>
                                <div className={ style.inputItem }>
                                    <img alt="" src={ icons.search_white_icon } style={{ width: "1.5rem", marginBottom: "-.5rem" }} /> 
                                    <input className={ style.searchInput } placeholder="Cerca utente" type="text" value={ searchMember } onChange={ e => setSearchMember(e.target.value) }></input>
                                </div>
                                { Object.values(schoolUsers)
                                    .filter(member => member.id !== user.id)
                                    .filter(member => member.username.toLowerCase().includes(searchMember.toLowerCase()) || member.email.toLowerCase().includes(searchMember.toLowerCase()))
                                    .filter(member => !schoolList.members?.includes(member.id)).map(member => <div key={ `member-${member.id}` } className={ style.user }>
                                        <img src={ member.profilePicture || `https://eu.ui-avatars.com/api/?name=${member.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                        <div className={ style.userDetails }>
                                            <h4 className={ style.username }>{  member.username }</h4>
                                            <h5 className={ style.userEmail }>{ member.email }</h5>
                                        </div>
                                        { user.id !== member.id && !schoolList.members?.includes(member.id) && !schoolList.invited?.includes(member.id) && <img src={ icons.invite_orange_icon } style={{ marginRight: "1rem" }} onClick={ async () => {
                                            updateSchoolList({ invited: [ ...(schoolList.invited ?? []), member.id ] });
                                            await updateDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`), { invited: [ ...(schoolList.invited ?? []), member.id ] });
                                        } }></img> }
                                        { user.id !== member.id && !schoolList.members?.includes(member.id) && schoolList.invited?.includes(member.id) && <img src={ icons.trash_icon } style={{ marginRight: "1rem" }} onClick={ async () => {
                                            updateSchoolList({ invited: (schoolList.invited ?? []).filter(invited => invited !== member.id) });
                                            await updateDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`), { invited: (schoolList.invited ?? []).filter(invited => invited !== member.id) });
                                        } }></img> }
                                </div>) }
                            </div>
                            <div className={ style.users } style={{ marginTop: "0", height: invitingMembersToSchoolList ? "0" : "fit-content", overflowY: invitingMembersToSchoolList ? "hidden" : "scroll", transition: "height .75s ease" }}>
                                { Object.values(schoolList.members ?? {}).map(member => schoolUsers[member]).map(member => <div key={ `member-${member.id}` } className={ style.user }>
                                    <img src={ member.profilePicture || `https://eu.ui-avatars.com/api/?name=${member.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                    <div className={ style.userDetails }>
                                        <h4 className={ style.username } style={{ marginTop: member.id === user.id && "0" }}>{ member.id === user.id ? "Tu" : member.username }</h4>
                                        { member.id !== user.id && <h5 className={ style.userEmail }>{ member.email }</h5> }
                                    </div>
                                </div>) }
                                { schoolList.invited?.length > 0 && <h4 className={ style.infoHeader } style={{ marginTop: "2rem", color: "var(--orange)" }}>Invitati</h4> }
                                { schoolList.invited?.map(invitedMember => schoolUsers[invitedMember]).map(invitedMember => <div key={ `member-${invitedMember.id}` } className={ style.user }>
                                    <img src={ invitedMember.profilePicture || `https://eu.ui-avatars.com/api/?name=${invitedMember.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                    <div className={ style.userDetails }>
                                        <h4 className={ style.username }>{ invitedMember.id === user.id ? "Tu" : invitedMember.username }</h4>
                                        { invitedMember.id !== user.id && <h5 className={ style.userEmail }>{ invitedMember.email }</h5> }
                                    </div>
                                    <img src={ icons.trash_icon } style={{ marginRight: "1rem" }} onClick={ async () => {
                                        updateSchoolList({ invited: (schoolList.invited ?? []).filter(invited => invited !== invitedMember.id) });
                                        await updateDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`), { invited: (schoolList.invited ?? []).filter(invited => invited !== invitedMember.id) });
                                    } }></img>
                                </div>) }
                            </div>
                        </section>
                        <section className={ style.schoolPresidentsList } style={{ height: page.page === "joinList" && "100%" }}>
                            <div className={ style.users }> 
                                { Object.values(schoolLists ?? {}).filter(list => list.invited?.includes(user.id)).map(list => <div key={ `schoolLists-${list.id}` } className={ style.user }>
                                    <img src={ list.logo || `https://eu.ui-avatars.com/api/?name=${list.name}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                    <div className={ style.userDetails }>
                                        <h4 className={ style.username } style={{ marginTop: "0" }}>{ list.name }</h4>
                                    </div>
                                    <img src={ icons.login_icon } onClick={ async () => {
                                        setUser(oldUser => ({ ...oldUser, schoolPresidentList: list.id }));
                                        setSchoolList({ ...list, invited: list.invited.filter(invited => invited !== user.id), members: [ ...(list.members ?? []), user.id ] });
                                        updateSchoolLists({ [list.id]: { ...list, invited: list.invited.filter(invited => invited !== user.id), members: [ ...(list.members ?? []), user.id ] } });

                                        await updateDoc(doc(db, `users/${user.id}`), { schoolPresidentList: list.id });
                                        await updateDoc(doc(db, `schools/${user.school}/presidentsLists/${list.id}`), { invited: list.invited.filter(invited => invited !== user.id), members: [ ...(list.members ?? []), user.id ] });
                                        setTitle("La tua lista");
                                        setPage({ page: "newList" });
                                    } }></img>
                                </div>) }
                            </div>
                        </section>
                        <section className={ style.schoolPresidents } style={{ height: page.page != null ? "0" : "100%", overflowY: page.page != null && "hidden" }} onClick={ () => setShowSchoolPresidentsPopup(false) }>
                            <div className={ style.modal } style={{ transform: showSchoolPresidentsPopup && "translateY(-50%)" }}>
                                <img src={ icons.info_icon } className={ style.modalIcon }></img>
                                <h3 className={ style.modalText }>
                                    I rappresentanti di istituto possono pubblicare annunci visibili a tutta la scuola, utili per comunicare le notizie importanti!<br></br><br></br>
                                    Sei un rappresentante di istituto? Clicca su "Crea lista" o "Entra in una lista"!
                                </h3>
                                <TextButton text="CHIUDI" style={{ marginTop: "1.5rem", marginLeft: "3rem", marginRight: "3rem" }} onClick={ () => setShowSchoolPresidentsPopup(false) } />
                            </div>
                            <div className={ style.flex }>
                                <h2 className={ style.sectionHeader } style={{ marginTop: "1rem", marginRight: "1rem", color: "white" }}>Rappresentanti di Istituto</h2>
                                <img src={ icons.info_icon } onClick={ e => {
                                    e.stopPropagation();
                                    setShowSchoolPresidentsPopup(true);
                                } }></img>
                            </div>
                            { Object.keys(schoolUsers).length > 100 ? <div>
                            {/* { Object.keys(schoolUsers).length > 1 ? <div> */}
                                <IconButton icon={ icons.test_icon } text={ user.schoolPresidentList ? "Modifica lista" : "Crea lista" } loading={ schoolList.loading } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" textStyle={{ fontSize: ".8rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ async () => {
                                    if (!user.schoolPresidentList) {
                                        setSchoolList({ loading: true });

                                        const docRef = doc(collection(db, `schools/${user.school}/presidentsLists`));
                                        await setDoc(docRef, { id: docRef.id, name: "", instagramURL: "", createdBy: user.id, logo: null, members: [ user.id ] });
                                        await updateDoc(doc(db, `users/${user.id}`), { schoolPresidentList: docRef.id });

                                        setUser(oldUser => ({ ...oldUser, schoolPresidentList: docRef.id }));
                                        setSchoolList({ id: docRef.id, name: "", instagramURL: "", createdBy: user.id, logo: null, members: [ user.id ] });
                                    }

                                    setTitle("La tua lista");
                                    setPage({ page: "newList" });
                                } } />
                                { Object.values(schoolLists ?? {}).filter(list => list.invited?.includes(user.id)).length > 0 && <IconButton icon={ icons.test_white_icon } text="Entra in una lista" textStyle={{ fontSize: ".8rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ () => {
                                    setTitle("Entra in una lista");
                                    setPage({ page: "joinList" });
                                } } /> }
                                <IconButton icon={ validatingPresidents ? icons.check_icon : icons.announcement_icon } textStyle={{ fontSize: ".8rem" }} background={ !validatingPresidents && "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" } text={ validatingPresidents ? "Conferma" : "Riconosci rappresentanti" } style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ async () => {
                                    if (validatingPresidents) {                                        
                                        const newSchoolPresidents = {};

                                        Object.entries(schoolPresidentsData).forEach(([candidate, votes]) => {
                                            if (candidate === "winners") return;

                                            if (votedSchoolPresidents.includes(candidate)) newSchoolPresidents[candidate] = Array.from(new Set([ ...votes, user.id ]));
                                            else newSchoolPresidents[candidate] = votes.filter(vote => vote !== user.id);
                                        });

                                        votedSchoolPresidents.forEach(vote => {
                                            if (newSchoolPresidents[vote] == undefined)
                                                newSchoolPresidents[vote] = [ user.id ];
                                        });

                                        newSchoolPresidents.winners = [];

                                        Object.entries(newSchoolPresidents).forEach(([candidate, votes]) => {
                                            if (candidate === "winners") return;

                                            if (votes.length > Object.keys(schoolUsers).length / 2)
                                                newSchoolPresidents.winners.push(candidate);
                                        });

                                        updateDoc(doc(db, `schools/${user.school}`), { presidents: newSchoolPresidents });
                                        updateDoc(doc(db, `schools/${user.school}/presidentsLists/${schoolList.id}`), { members: arrayRemove(user.id    ) });
                                        setSchoolPresidents(newSchoolPresidents);
                                        setSchoolPresidentsData(newSchoolPresidents);
                                    }

                                    setValidatingPresidents(oldValidatingPresidents => !oldValidatingPresidents);
                                } } />
                                { !validatingPresidents && schoolPresidentsData.winners?.includes(user.id) && <IconButton icon={ icons.announcement_white_icon } text="Crea annuncio" textStyle={{ fontSize: ".8rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} onClick={ () => setGlobalPage({ page: "schoolAnnouncement" }) } /> }
                                <h3 className={ style.sectionHeader }>{ validatingPresidents ? "Rappresentanti candidati" : "Rappresentanti eletti" }</h3>
                                <div className={ style.users } style={{ height: validatingPresidents ? "100%" : "0", transition: "height .75s ease", overflowY: validatingPresidents ? "scroll" : "hidden" }}>
                                    { Object.values(schoolLists ?? {}).map(list => <div key={ `schoolList-${list.id}` }>
                                        <h4 className={ style.infoHeader }>Lista "<span style={{ color: "var(--orange)" }}>{ list.name }</span>"</h4>
                                        { Object.values(schoolUsers).filter(schoolUser => schoolUser.schoolPresidentList === list.id && schoolUser.id !== user.id).map(schoolUser => <div className={ style.user } key={ `schoolPresidentCandidate-${schoolUser.id}` }>
                                            <img src={ schoolUser.profilePicture || `https://eu.ui-avatars.com/api/?name=${schoolUser.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                            <div className={ style.userDetails }>
                                                <h4 className={ style.username }>{ schoolUser.username }</h4>
                                                <h5 className={ style.userEmail }><span style={{ color: "var(--orange)" }}>{ schoolPresidentsData[schoolUser.id]?.length ?? 0 }</span> voti</h5>
                                            </div>
                                            <Checkbox id={ `schoolPresidentCandidate-${schoolUser.id}` } style={{ marginLeft: "-2rem" }} checked={ votedSchoolPresidents.includes(schoolUser.id) } onChange={ e => setVotedSchoolPresidents(oldVotes => (e.target.checked ? [ ...oldVotes, schoolUser.id ] : oldVotes.filter(vote => vote !== schoolUser.id))) } />
                                        </div>) }
                                    </div>) }
                                </div>
                                <div className={ style.users } style={{ height: (validatingPresidents || (schoolPresidentsData?.winners ?? []).length === 0) ? "0" : "100%", transition: "height .75s ease", overflowY: validatingPresidents ? "hidden" : "scroll" }}>
                                    { (schoolPresidentsData?.winners ?? []).map(schoolUser => schoolUsers[schoolUser]).map(schoolUser => <div key={ `schoolPresident-${schoolUser.id}` } className={ style.user }>
                                        <img src={ schoolUser.profilePicture || `https://eu.ui-avatars.com/api/?name=${schoolUser.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                                        <div className={ style.userDetails }>
                                            <h4 className={ style.username }>{ schoolUser.id === user.id ? "Tu" : schoolUser.username }</h4>
                                            <h5 className={ style.userEmail }>{ schoolLists[schoolUser.schoolPresidentList]?.name }</h5>
                                        </div>
                                    </div>) }
                                </div>
                                { !validatingPresidents && (schoolPresidentsData.winners?.length === 0 || schoolPresidentsData.winners?.length == undefined) && <div>
                                    <Lottie 
                                        style={{ marginTop: "2rem", marginLeft: "auto", marginRight: "auto", width: "65vw" }}
                                        loop={ true }
                                        autoplay={ true }
                                        animationData={ students_animation }
                                    />
                                    <h4 className={ style.infoHeader }>Clicca su "Riconosci rappresentanti" per eleggere i tuoi rappresentanti di Istituto!</h4>
                                </div> }
                            </div> :
                            <div>
                                <Lottie 
                                    style={{ marginTop: "2rem", marginLeft: "auto", marginRight: "auto", width: "65vw" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ brainstorming_animation }
                                    // animationData={ students_animation }
                                />
                                <h4 className={ style.infoHeader }>La tua scuola deve avere almeno <span style={{ color: "var(--orange)" }}>100 studenti</span> iscritti per riconoscere i rappresentanti di Istituto</h4>
                            </div> } 
                        </section>
                    </>
                case "classroom":
                    return <>
                        <Banner id="classroom" style={{ marginTop: "1rem" }} />
                        <section className={ style.classroomSubject } style={{ height: classroomSubjectPopup.show && "100%" }}>
                            <h4 className={ style.classroomSubjectCourse }>{ classroomSubjectPopup.course?.name }</h4>
                            <div className={ style.subjectsGrid }>
                                <div key={ `classroomSubjects-none` } className={ style.subjectContainer } onClick={ () => {
                                    setClassroomSubjectPopup(oldPopup => ({ ...oldPopup, show: true, subject: null }));
                                    saveClassroomSubject(null);
                                } }>
                                    <div className={ style.subject } /*style={{ background: !classroomSubjectPopup.subject && "rgb(28, 126, 255)" }}*/>
                                        <img src={ icons.question_mark_orange_icon } className={ style.subjectIcon }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>Nessuno</h6>
                                </div>
                                { subjects && Object.values(subjects).map(subject => <div key={ `classroomSubjects-${subject.subject}` } className={ style.subjectContainer } onClick={ () => {
                                    setClassroomSubjectPopup(oldPopup => ({ ...oldPopup, show: true, subject: subject.subject }));
                                    saveClassroomSubject(subject.subject);
                                } }>
                                    <div className={ style.subject } /*style={{ background: classroomSubjectPopup.subject === subject.subject && "rgb(28, 126, 255)" }}*/>
                                        <img src={ icons[subject.icon] } className={ style.subjectIcon }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>{ subject.subject }</h6>
                                </div>) }
                            </div>
                        </section>
                        <section className={ style.classroom } style={{ height: classroomSubjectPopup.show && "0" }}>
                            { (classroomCourses && classroomAccessToken) && subjects && Object.values(classroomCourses).map(course => {
                                let subject = null;
                                if (typeof user.classroomSubjects?.[course.id] == "undefined" && user.classroomSubjects?.[course.id] !== false)
                                    Object.values(subjects).forEach(classSubject => { 
                                        if (classSubject.subject.toLowerCase().includes(course.name.toLowerCase()) || course.name.toLowerCase().includes(classSubject.subject.toLowerCase())) 
                                            subject = classSubject;
                                    });
                                else if (user.classroomSubjects?.[course.id] !== false)
                                    subject = subjects?.[user.classroomSubjects[course.id]];
                                return <div key={ course.id } className={ style.classroomCourse } onClick={ () => setClassroomSubjectPopup({ show: true, subject, course }) }>
                                    <img src={ icons[getSubjectIcon(subject?.subject)] } style={{ marginLeft: "1rem", marginRight: "1rem", width: "2rem", height: "2rem", display: "block", marginTop: "auto", marginBottom: "auto" }}></img>
                                    <div>
                                        <h4 style={{ marginTop: "1rem", marginBottom: "0" }}>{ course.name }</h4>
                                        <h5 style={{ marginTop: ".5rem", marginBottom: "1rem" }}>{ subject?.subject ?? "???" }</h5>
                                    </div>
                                </div>
                            }) }
                            <IconButton loading={ !user || loadingClassroom } text={ classroomAccessToken ? "SCOLLEGA" : "COLLEGA" } icon={ classroomAccessToken ? icons.logout_white_icon : icons.login_icon } fontSize="1rem" style={{ marginTop: "3rem", padding: ".5rem 0", background: classroomAccessToken && "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} onClick={ async () => {                                
                                setLoadingClassroom(true);
                                if (classroomAccessToken) {
                                    await revokeToken(user);
                                    setClassroomAccessToken(null);
                                    setLoadingClassroom(false);
                                    localStorage.setItem("loggedInClassroom", false);
                                    return;
                                }

                                await loadClassroomAPI(user, async token => {
                                    setClassroomAccessToken(token);
                                    setLoadingClassroom(false);
                                    const [newEvents, updatedEvents] = await fetchEvents(offline, homeworks, setHomeworks, timetable, user);
                                    setNewEvents(newEvents);
                                    setUpdatedEvents(updatedEvents);
                                });

                                let authenticated = await authenticateClassroomAPI(user);
                                if (authenticated === true) {                          
                                    // setClassroomAccessToken(true);
                                    setLoadingClassroom(false);
                                    return;
                                }

                                setClassroomAccessToken(authenticated);
                                setLoadingClassroom(false);
                                const [newEvents, updatedEvents] = await fetchEvents(offline, homeworks, setHomeworks, timetable, user);
                                setNewEvents(newEvents);
                                setUpdatedEvents(updatedEvents);
                            } } />
                        </section>
                    </>
                case "register":
                    return <>
                        <Banner id="register" style={{ marginTop: "1rem" }} />
                        <section className={ style.classroomSubject } style={{ height: classroomSubjectPopup.show && "100%" }}>
                            <h4 className={ style.classroomSubjectCourse }>{ classroomSubjectPopup.course?.name }</h4>
                            <div className={ style.subjectsGrid }>
                                <div key={ `registerSubjects-none` } className={ style.subjectContainer } onClick={ () => {
                                    setRegisterSubjectPopup(oldPopup => ({ ...oldPopup, show: true, subject: null }));
                                    saveRegisterSubject(null);
                                } }>
                                    <div className={ style.subject } /*style={{ background: !classroomSubjectPopup.subject && "rgb(28, 126, 255)" }}*/>
                                        <img src={ icons.question_mark_orange_icon } className={ style.subjectIcon }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>Nessuno</h6>
                                </div>
                                { subjects && Object.values(subjects).map(subject => <div key={ `registerSubjects-${subject.subject}` } className={ style.subjectContainer } onClick={ () => {
                                    setRegisterSubjectPopup(oldPopup => ({ ...oldPopup, show: true, subject: subject.subject }));
                                    saveRegisterSubject(subject.subject);
                                } }>
                                    <div className={ style.subject } /*style={{ background: classroomSubjectPopup.subject === subject.subject && "rgb(28, 126, 255)" }}*/>
                                        <img src={ icons[subject.icon] } className={ style.subjectIcon }></img>
                                    </div>
                                    <h6 className={ style.subjectName }>{ subject.subject }</h6>
                                </div>) }
                            </div>
                        </section>
                        <section className={ style.classroom } style={{ height: registerSubjectPopup.show && "0" }}>
                            { (registerCourses && registerAccessToken) && subjects && Object.values(registerCourses).map(course => {
                                let subject = null;
                                if (typeof user.registerSubjects?.[course.id] == "undefined" && user.registerSubjects?.[course.id] !== false)
                                    Object.values(subjects).forEach(classSubject => { 
                                        if (classSubject.subject.toLowerCase().includes(course.name.toLowerCase()) || course.name.toLowerCase().includes(classSubject.subject.toLowerCase())) 
                                            subject = classSubject;
                                    });
                                else if (user.registerSubjects?.[course.id] !== false)
                                    subject = subjects?.[user.registerSubjects[course.id]];
                                return <div key={ course.id } className={ style.classroomCourse } onClick={ () => setRegisterSubjectPopup({ show: true, subject, course }) }>
                                    <img src={ icons[getSubjectIcon(subject?.subject)] } style={{ marginLeft: "1rem", marginRight: "1rem", width: "2rem", height: "2rem", display: "block", marginTop: "auto", marginBottom: "auto" }}></img>
                                    <div>
                                        <h4 style={{ marginTop: "1rem", marginBottom: "0" }}>{ course.name }</h4>
                                        <h5 style={{ marginTop: ".5rem", marginBottom: "1rem" }}>{ subject?.subject ?? "???" }</h5>
                                    </div>
                                </div>
                            }) }
                            <IconButton loading={ !user || loadingClassroom } text={ classroomAccessToken ? "SCOLLEGA" : "COLLEGA" } icon={ classroomAccessToken ? icons.logout_white_icon : icons.login_icon } fontSize="1rem" style={{ marginTop: "3rem", padding: ".5rem 0", background: classroomAccessToken && "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} onClick={ async () => {                                
                                setLoadingRegister(true);
                                if (registerAccessToken) {
                                    setRegisterAccessToken(null);
                                    setLoadingRegister(false);
                                    localStorage.setItem("loggedInRegister", false);
                                    return;
                                }

                                await loadClassroomAPI(user, async token => {
                                    setClassroomAccessToken(token);
                                    setLoadingRegister(false);
                                    const [newEvents, updatedEvents] = await fetchEvents(offline, homeworks, setHomeworks, timetable, user);
                                    setNewEvents(newEvents);
                                    setUpdatedEvents(updatedEvents);
                                });

                                let authenticated = await authenticateClassroomAPI(user);
                                if (authenticated === true) {                          
                                    // setClassroomAccessToken(true);
                                    setLoadingRegister(false);
                                    return;
                                }

                                setClassroomAccessToken(authenticated);
                                setLoadingRegister(false);
                                const [newEvents, updatedEvents] = await fetchEvents(offline, homeworks, setHomeworks, timetable, user);
                                setNewEvents(newEvents);
                                setUpdatedEvents(updatedEvents);
                            } } />
                        </section>
                    </>
                case "premium":
                    return <section>
                        <Banner id="premium" style={{ marginTop: "1rem" }} />
                        <Popup show={ premiumSubscriptionCancel.showModal } onClick={ e => {
                            setPremiumSubscriptionCancel({ showModal: false });
                        } } text="Sei sicuro di voler cancellare la tua iscrizione a SchoolDiary Premium?" icon={ icons.warning_icon } buttons={
                            <IconButton background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" text="CANCELLA" loading={ premiumSubscriptionCancel.cancelling } icon={ icons.trash_white_icon } onClick={ e =>{
                                e.stopPropagation();
                                cancelStripeSubscription();
                            } } />
                        } />
                        <div className={ style.premiumContainer } style={{ background: (user?.premium) && "rgb(83, 82, 82)", marginTop: "2rem" }}>
                            <h3>SchoolDiary  <span style={{ color: "var(--orange)" }}>Premium</span></h3>
                            <h4 style={{
                                marginLeft: "1rem",
                                fontSize: "1.5rem",
                                marginTop: "-.5rem",
                                marginBottom: "1rem",
                            }}>€2,99 <span style={{ fontSize: ".7rem" }}>al mese</span></h4>
                            <h4 style={{
                                marginLeft: "1rem",
                                fontSize: "1.5rem",
                                marginTop: "-.5rem",
                                marginBottom: "1rem",
                            }}>o <span style={{ color: "var(--orange)" }}>{ user?.invitedFriends ?? 0 }</span>/3 <span style={{ fontSize: ".7rem" }}>amici invitati</span></h4>
                            <hr className={ style.separator }></hr>
                            <div className={ [style.premiumListItem, !(user?.premium) && style.disabled].join(" ") } style={{ marginTop: "0" }}>
                                <img src={ user?.premium ? icons.check_icon : icons.check_icon_disabled }></img>
                                <h5>Nessuna pubblicità</h5>
                            </div>
                            <div className={ [style.premiumListItem, !(user?.premium) && style.disabled].join(" ") }>
                                <img src={ user?.premium ? icons.check_icon : icons.check_icon_disabled }></img>
                                <h5>Aggiungi allegati agli eventi</h5>
                            </div>
                            <div className={ [style.premiumListItem, !(user?.premium) && style.disabled].join(" ") }>
                                <img src={ user?.premium ? icons.check_icon : icons.check_icon_disabled }></img>
                                <h5>Detta gli eventi</h5>
                            </div>
                        </div>
                        { !(user?.premium) ?
                            <>
                                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" onClick={ handleStripeSubmit } icon={ icons.premium_icon } text="ISCRIVITI A PREMIUM" loading={ generatingStripeCheckout } />
                                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} onClick={ () => navigator.share({ 
                                        text: "Unisciti anche tu a SchoolDiary, il diario digitale condiviso con tutta la tua classe!",
                                        url: `https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}&user=${user.id}`
                                    }) } icon={ icons.invite_orange_icon } background={ "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" } text={ "INVITA UN AMICO" } />
                                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} onClick={ copyPremiumInviteLink } icon={ premiumInviteLinkCopied ? icons.check_icon : icons.copy_to_clipboard_icon } background={ premiumInviteLinkCopied && "linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))" } text={ premiumInviteLinkCopied ? "INVITO COPIATO" : "COPIA IL TUO INVITO" } />
                            </> :
                            <>
                                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem"  }} background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" onClick={ () => handleStripeSubmit(false) } text="DETTAGLI ISCRIZIONE" icon={ icons.premium_icon } loading={ generatingStripeCheckout } />                                    
                                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" text="CANCELLA ISCRIZIONE" icon={ icons.trash_white_icon } loading={ generatingStripeCheckout } onClick={ e => {
                                    setPremiumSubscriptionCancel({ showModal: true });
                                    e.stopPropagation();
                                }}/>
                            </> }
                    </section>;
                case "calendar":
                    return <>
                        <Banner id="profile" style={{ marginTop: "1rem" }} />
                        { calendar && <section className={ style.calendar }>
                            <h3 className={ style.month }>{ getItalianMonth(calendar[calendarActiveSlide][0].getMonth()) } { calendar[calendarActiveSlide][0].getFullYear() }</h3>
                            <div className={ style.week } style={{ background: "rgb(80, 80, 80)", marginBottom: "0", borderRadius: ".5rem" }}>
                                <p className={ style.day }>L</p>
                                <p className={ style.day }>M</p>
                                <p className={ style.day }>M</p>
                                <p className={ style.day }>G</p>
                                <p className={ style.day }>V</p>
                                <p className={ style.day }>S</p>
                                <p className={ style.day }>D</p>
                            </div>
                            <Swiper direction='vertical' slidesPerView={ 4 } style={{ height: "26vh" }} ref={ swiper } onSwiper={ () => setSwiperLoaded(true) } onSlideChange={ ({ activeIndex }) => setCalendarActiveSlide(activeIndex) }>
                                { calendar.map((week, index) => <SwiperSlide key={ index } style={{ height: "5vh", marginTop: "1.5vh" }}>
                                    <div className={ style.week }>
                                        { week.map(day => <div key={ `calendar-${day.getDate()}-${day.getMonth()}` } className={ style.day }>
                                            <p className={ [style.day, compareDates(day, date) && style.selected, compareDates(day, new Date()) && style.today].join(" ") } onClick={ () => setDate(day) }>{ day.getDate() }</p>
                                        </div>) }
                                    </div>
                                </SwiperSlide>) }
                            </Swiper>
                        </section> }
                        <TextButton loading={ updatingTermsSeparator } text="INIZIO SECONDO PERIODO" style={{ marginTop: "1rem", marginLeft: "2rem", marginRight: "2rem" }} onClick={ async () => {
                            setUpdatingTermsSeparator(true);
                            await updateDoc(doc(db, `schools/${user.school}/classes/${user.class}`), { "calendar.termsSeparator": date.toString() });
                            setUpdatingTermsSeparator(false);
                        } } />
                    </>;
                default:
                    return <></>;
            }
        })() }
    </main>
};

export default Option;